export default __webpack_public_path__ + "static/media/Alisher-Efremov.ad77faaf.png";